import { Flex } from 'antd';
import { TextComponent } from 'baseComponents/TextComponent';
import { HTMLAttributes, ReactNode } from 'react';
import './styles.scss';

export type InputComponentWrapperProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  label?: string;
  description?: string;
  error?: string;
  fullWidth?: boolean;
};

export const InputComponentWrapper = ({
  children,
  label,
  error,
  description,
  fullWidth,
  ...rest
}: InputComponentWrapperProps) => {
  return (
    <Flex
      vertical
      className={`${fullWidth && 'pj-input-wrapper-full'}`}
      {...rest}
    >
      <Flex justify='space-between' gap={4}>
        {label && (
          <TextComponent weight='extra-light' text={label} type='span' />
        )}
        {description && (
          <TextComponent
            weight='extra-light'
            size='small'
            text={description}
            type='span'
            opacity
          />
        )}
      </Flex>
      {children}
      {error && (
        <TextComponent
          weight='extra-light'
          size='small'
          text={error}
          type='span'
          styleType='danger'
        />
      )}
    </Flex>
  );
};
